import { siteApiSlice } from "../../app/siteApiSlice";
import { UserRole } from "../../app/userSlice";

export enum SupportQuestionType {
	AccommodationsAccessibility = "Accommodations/Accessibility",
	AccountSettingsCredentials = "Account Settings/Credentials",
	ClassesRoster = "Classes/Roster",
	Clever = "Clever",
	ClassLink = "ClassLink",
	ErrorMessagePerformanceIssues = "Error Message/Performance Issues",
	Feedback = "Feedback",
	LoginPassword = "Login/Password",
	Prompts = "Prompts",
	Reports = "Reports",
	Scoring = "Scoring",
	Suggestion = "Suggestion",
	PDTraining = "PD/Training",
	Other = "Other",
}

export interface ContactSupportViewModel {
	role: UserRole;
	userName: string;
	userFullName: string;
	email: string;
	userHasEmail: boolean;
	district: string;
	school: string;
	courseId: string;
	courseName: string;
	question: string;
	questionType?: string;
	attachmentFileName: string;
	attachment: string;
	url: string;
}

export const supportApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		getContactSupportInfo: build.query<ContactSupportViewModel, void>({
			query: () => ({ url: `/Support/ContactSupport`, method: "POST" }),
			providesTags: ["CurrentCourse", "CurrentSchool", "CurrentDistrict"],
		}),
		contactSupport: build.mutation<void, ContactSupportViewModel>({
			query: (payload) => {
				const formData = new FormData();

				const { attachment, ...model } = payload;

				if (payload.attachment) {
					formData.append("attachment", payload.attachment);
				}
				formData.append("model", JSON.stringify(model));

				return {
					url: `/Support/SendContactSupportMailSpa`,
					method: "POST",
					body: formData,
				};
			},
		}),
	}),
});

export const { useGetContactSupportInfoQuery, useContactSupportMutation } = supportApiSlice;
